'use client'

import * as React from 'react'
import { RealPhotos } from '@/components/roostr'
import { useUIStore } from '@/lib/store'

// GalleryMosaic — design detail.jsx:18-26. Full-width, image-first carousel:
// height 58vw on mobile / min(46vw, 520px) on desktop, shape-lg radius.
// Clicking the photo (not the arrows — they stopPropagation) opens the
// production full-screen gallery at the currently shown index.
export interface DetailHeroProps {
  /** Proxied image URLs. */
  images: string[]
  alt: string
  onOpen: (index: number) => void
}

export function DetailHero({ images, alt, onOpen }: DetailHeroProps) {
  const [idx, setIdx] = React.useState(0)
  const n = images.length

  // ArrowLeft / ArrowRight flip the hero carousel (parity with the pre-redesign
  // hero). Suppressed while typing in a field and while the full-screen gallery
  // is open — it has its own arrow-key handler.
  React.useEffect(() => {
    if (n <= 1) return
    const h = (e: KeyboardEvent) => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return
      if (useUIStore.getState().galleryOpen) return
      const el = e.target as HTMLElement | null
      if (
        el &&
        (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' || el.isContentEditable)
      )
        return
      setIdx((i) => (i + (e.key === 'ArrowRight' ? 1 : -1) + n) % n)
    }
    window.addEventListener('keydown', h)
    return () => window.removeEventListener('keydown', h)
  }, [n])

  return (
    <div
      className="mt-[10px] h-[58vw] cursor-pointer overflow-hidden rounded-shape-lg md:h-[min(46vw,520px)]"
      onClick={() => onOpen(idx)}
    >
      <RealPhotos images={images} alt={alt} fillHeight radius={20} index={idx} onIndexChange={setIdx} />
    </div>
  )
}
